// extracted by mini-css-extract-plugin
module.exports = {"container":"dece2e673c--container--2qxIG","comment_controls":"dece2e673c--comment_controls--hGLxD"};